import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, Divider, InputAdornment, Tooltip, Typography } from '@mui/material';

import { Icon, IconOption, Menu } from '@components/base';

import { GlobalSearchTextFieldProps, groupedSearchContexts } from './utils';

type GlobalSearchFieldDropDownProps = Pick<
  GlobalSearchTextFieldProps,
  'hasFocus' | 'searchContext' | 'setElementFocus' | 'setSearchContext'
>;

const GlobalSearchFieldDropDown: FC<GlobalSearchFieldDropDownProps> = ({
  searchContext,
  setElementFocus,
  setSearchContext,
  hasFocus,
}) => {
  const { t } = useTranslation();

  return (
    <InputAdornment position='end'>
      <Collapse in={hasFocus} orientation='horizontal'>
        <Menu
          onClose={() => setElementFocus('menu', false)}
          onOpen={() => setElementFocus('menu', true)}
        >
          <Menu.Button
            color='inherit'
            onBlur={() => setElementFocus('button', false)}
            onFocus={() => setElementFocus('button', true)}
            rightIcon='arrowDropDown'
          >
            {t('search.context', { context: searchContext })}
          </Menu.Button>

          <Menu.Content slotProps={{ paper: { sx: { minWidth: 260 } } }}>
            {Object.entries(groupedSearchContexts).map(([type, searchContexts]) => [
              <Divider key={type} textAlign='left'>
                <Typography variant='caption'>{t(type)}</Typography>
              </Divider>,

              ...searchContexts.map(sc => (
                <Tooltip
                  key={sc}
                  placement='left'
                  title={t('search.context.hint', { context: sc })}
                >
                  <Menu.Item
                    icon={<Icon name={type as IconOption} />}
                    onClick={() => setSearchContext(sc)}
                    selected={sc === searchContext}
                  >
                    {t('search.context', { context: sc })}
                  </Menu.Item>
                </Tooltip>
              )),
            ])}
          </Menu.Content>
        </Menu>
      </Collapse>
    </InputAdornment>
  );
};

export default GlobalSearchFieldDropDown;
